import { render, staticRenderFns } from "./CreateEditKid.vue?vue&type=template&id=5bf19e32&scoped=true"
import script from "./CreateEditKid.vue?vue&type=script&lang=js"
export * from "./CreateEditKid.vue?vue&type=script&lang=js"
import style0 from "./CreateEditKid.vue?vue&type=style&index=0&id=5bf19e32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf19e32",
  null
  
)

export default component.exports